export enum PAGES {
  "Home" = "/",
  "Advertising" = "/manage/advertising",
  "Opportunities report" = "/searchTermsTrends",
  "Projects" = "/projects",
  "Project data" = "/project-data",
  "History" = "/history",
  "History (SP SKC)" = "/advertising/history",
  "History (SP)" = "/advertising/historyManyTargetsCampaigns",
  "Advertizing campaign" = "/advertising/campaign",
  "History (SB/SD)" = "/sb-sd-history",
  "Filter" = "/filter",
  "ACOS Filter" = "/settings/acos",
  "Other Filter" = "/settings/other",
  "Unmanage campaign" = "/settings/unmange-campaign",
  "Users" = "/roles",
  "all" = "all",
}

export enum PAGE_NAMES {
  SPONSORED_PRODUCTS_SKC = "Sponsored Products (SKC)",
  SPONSORED_PRODUCTS = "Sponsored Products",
  SPONSORED_BRANDS = "Sponsored Brands",
  SPONSORED_DISPLAY = "Sponsored Display",
  ADVERTISING = "Advertising",
  OPPORTUNITIES_REPORT = "Opportunities report",
  PROJECTS = "Projects",
  HISTORY = "History",
  FILTER = "Filter",
  SETTINGS_ACOS = "ACOS Filter",
  SETTINGS_OTHER = "Other Settings",
  USERS = "Users",
  ALL = "all",
}
